import { css } from 'styled-components';

import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/constants/breakpoints';
import { IContentCardItem } from '~/src/features/movix-new/ContentCard';

const titleStyles = css`
    @media (max-width: ${breakPoints.tablet}) {
        ${FONTS.H4};
    }
`;

const imageStyles = css`
    @media (max-width: ${breakPoints.tablet}) {
        min-height: 88px;
        min-width: 88px;
        max-width: 88px;
    }

    @media (max-width: ${breakPoints.mobile}) {
        margin-bottom: 10px;
    }
`;

const containerStyles = css`
    @media (max-width: ${breakPoints.tablet}) {
        padding-bottom: 18px;
    }
`;

export const CARDS: IContentCardItem[] = [
    {
        title: 'Целый раздел с безопасным детским контентом',
        description: 'Увлекательные ТВ-каналы, любимые коллекции мультфильмов от ведущих мировых студий, ' +
            'а также подборки о роботах, принцессах, драконах и других героях.',
        img: 'static/images/movix-new/for-kids.png',
        area: 'large',
        imageStyles: css`
            max-height: 165px;
            min-width: 483px;
            border-radius: 0;
            margin-right: 14px;

            @media (max-width: ${breakPoints.tablet}) {
                min-width: 302px;
                min-height: 120px;
                margin-right: 12px;
                margin-bottom: 0px;

                background-image: url(static/images/movix-new/for-kids-mobile.png);
                background-size: cover;

                & img {
                display: none;
                }
            }

            @media (max-width: ${breakPoints.mobile}) {
                max-width: 282px;
                min-width: 282px;
                min-height: 112px;
                margin: -40px 0 10px;
            }
        `,
        containerStyles: css`
            height: fit-content;

            @media (max-width: ${breakPoints.tablet}) {
                padding-bottom: 8px;
                column-gap: 10px;
            }

            @media (max-width: ${breakPoints.mobile}) {
                padding-top: 48px;
                padding-bottom: 21px;
            }
        `,
        titleStyles: css`
            @media (max-width: ${breakPoints.mobile}) {
                ${FONTS.H5};
            }
        `,
    },
    {
        title: 'Дети больше не требуют ваш телефон для игр и мультиков',
        img: 'static/images/movix-new/phone.svg',
        area: 'first',
        titleStyles,
        imageStyles: css`
            margin-right: 42px;

            img{
                max-height: 95px;
            }

            @media (max-width: ${breakPoints.tablet}) {
                margin-right: 0;
            }
        `,
        containerStyles: css`
            ${containerStyles};
            @media (max-width: ${breakPoints.tablet}) {
                column-gap: 16px;
            }
        `,
    },
    {
        title: 'Мультфильмы на большом экране, а не на дисплее телефона',
        img: 'static/images/movix-new/humansuit.svg',
        area: 'second',
        titleStyles,
        imageStyles: css`
            ${imageStyles};
            margin-right: 42px;

            @media (max-width: ${breakPoints.tablet}) {
                margin-right: 0;
            }

            @media (max-width: ${breakPoints.mobile}) {
                margin-bottom: 8px;
            }
        `,
        containerStyles,
    },
];
